import { render } from "./PolicyAdministrationView.vue?vue&type=template&id=109f8aae"
const script = {}

import exportComponent from "/Users/baojian/Documents/coipor/anyway-wx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__